import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Message } from "src/app/_model/message";
import { InitializeStatus } from "src/app/_services/initialize/initialize-aware";
import { LoggingService } from "src/app/_services/logging/logic/logging.service";
import { MessagesService } from "../message.service";
import { BadgesService } from "src/app/_services/badges/logic/badges.service";
import { MessagesDaoService } from "../../dao/message-dao.service";
import { PushNotificationsService } from "src/app/_services/push-notifications/logic/push-notifications.service";
import { IMSAction } from "src/app/_model/menu";

@Injectable()
export class MessagesLogicService implements MessagesService {
  public messages$ = new BehaviorSubject<Message[]>([]);
  public initializeStatus$: BehaviorSubject<InitializeStatus> = new BehaviorSubject(InitializeStatus.NOT_INITIALIZED);

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private messagesDaoService: MessagesDaoService,
    private badgesService: BadgesService,
    private notificationService: PushNotificationsService
  ) {
    this.initialize();
  }

  // Public Function

  public async addMessage(message: Message): Promise<void> {
    this.logger.log(this.constructor.name, 'Adding message:', message);
    await this.messagesDaoService.addMessage(message);
    await this.loadLocalMessages();
    const action: IMSAction = {
      type: 'navigation',
      target: 'messages',
    }
    var notificationText = ""
    if (message.subject) {
      notificationText += `${message.subject}\n`
    }
    notificationText += message.plainText
    await this.notificationService.sendLocalNotification(`Neue Nachricht von ${message.sender}`, notificationText, action)
  }

  public async setMessageToRead(message: Message): Promise<void> {
    await this.messagesDaoService.setMessageToRead(message);
    await this.loadLocalMessages();
  }

  // Resetable
  public async reset() {
    await this.messagesDaoService.reset();
    await this.loadLocalMessages();
  }

  public async clear() {
    await this.messagesDaoService.clear();
    this.messages$.next([]);
  }


  // InitializeAware
  async initialize(): Promise<void> {
    this.initializeStatus$.next(InitializeStatus.INITIALIZING)
    try {
      await this.loadLocalMessages();
      this.initializeStatus$.next(InitializeStatus.INITIALIZED)
    } catch (error) {
      this.logger.error(
        this.constructor.name,
        'Error loading local data: ',
        error?.message
      );
      this.initializeStatus$.next(InitializeStatus.FAILED_INITIALIZE)
    }
  }

  // Private Functions
  private async loadLocalMessages() {
    try {
      this.logger.log(this.constructor.name, '- Load local Messages');
      let messages: Message[] = await this.messagesDaoService.getMessages();
      this.logger.log(
        this.constructor.name,
        '- Loaded local Messages',
        messages.length,
        messages
      );
      this.messages$.next(messages);

      const unreadCount = messages.filter((it) => it.read === false).length
      await this.badgesService.setUnreadMessages(unreadCount);
    } catch (error) {
      this.logger.error(
        this.constructor.name,
        'Error loading local messages: ',
        error.message
      );
      throw error;
    }
  }

  async initializeCompleted(): Promise<void> {

  }

}
